module.exports = __webpack_public_path__ + "img/icon_add.98ee232e.png";